
// import { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import API_URL from "../../config/api";
// import "./newProduct.css";

// const NewProduct = () => {
//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(false);

//   const [product, setProduct] = useState({
//     name: "",
//     stock: "",
//     status: "Active",
//     image: "",
//     price: "",
//     category: "",
//     subcategory: "",

//     brand: "",
//     sizes: [],
//     colors: [],
//     description: "",


//      isFeatured: false,
//   isPopular: false,
//   isTrending: false,
//   isTopSelling: false,
//   isDealsOfDay: false,
//   });


//   const uploadImageToCloudinary = async (file) => {
//     const data = new FormData();
//     data.append("file", file);
//     data.append("upload_preset", "SulavSewa");
//     data.append("cloud_name", "dknqhkkhy");

//     try {
//       const res = await fetch(
//         "https://api.cloudinary.com/v1_1/dknqhkkhy/image/upload",
//         {
//           method: "POST",
//           body: data,
//         }
//       );

//       const result = await res.json();
//       return result.secure_url;
//     } catch (err) {
//       console.error("Upload failed", err);
//       return null;
//     }
//   };


//   const handleChange = (e) => {
//     setProduct({
//       ...product,
//       [e.target.name]: e.target.value,
//     });
//   };


//   const handleImage = async (e) => {
//     const file = e.target.files[0];

//     if (file) {
//       setLoading(true);

//       const imageUrl = await uploadImageToCloudinary(file);

//       setLoading(false);

//       if (imageUrl) {
//         setProduct({
//           ...product,
//           image: imageUrl,
//         });
//       }
//     }
//   };

// const handleSubmit = async (e) => {
//   e.preventDefault();

//   // ✅ Basic validation
//   if (!product.name.trim()) {
//     alert("Product name is required");
//     return;
//   }

//   if (!product.price) {
//     alert("Price is required");
//     return;
//   }

//   if (!product.image) {
//     alert("Please upload image");
//     return;
//   }

//   // ✅ Clean + format data before sending
//   const payload = {
//   name: product.name.trim(),
//   image: product.image,
//   price: Number(product.price),
//   stock: product.stock ? Number(product.stock) : 0,
//   category: product.category || "General",
//   subcategory: product.subcategory || "",
//   brand: product.brand || "",
//   sizes: product.sizes || [],
//   colors: product.colors || [],
//   description: product.description || "",
//   status: product.status || "Active",

//   // ✅ ADD THESE
//   isFeatured: product.isFeatured,
//   isPopular: product.isPopular,
//   isTrending: product.isTrending,
//   isTopSelling: product.isTopSelling,
//   isDealsOfDay: product.isDealsOfDay,
  
// };
//   // const payload = {
//   //   name: product.name.trim(),
//   //   image: product.image,
//   //   price: Number(product.price),
//   //   stock: product.stock ? Number(product.stock) : 0,
//   //   category: product.category || "General",
//   //   subcategory: product.subcategory || "",
//   //   brand: product.brand || "",
//   //   sizes: product.sizes || [],
//   //   colors: product.colors || [],
//   //   description: product.description || "",
//   //   status: product.status || "Active",
//   // };

//   try {
//     const res = await fetch(`${API_URL}/api/products`, {
//       method: "POST",
//       headers: {
//         "Content-Type": "application/json",
//       },
//       body: JSON.stringify(payload),
//     });

//     const data = await res.json();

//     console.log("CREATED:", data);

//     alert("Product Created Successfully");

//     navigate("/products");
//   } catch (err) {
//     console.error(err);
//     alert("Error creating product");
//   }
// };
//   return (
//     <div className="newProduct">
//       <h1 className="addProductTitle">New Product</h1>

//       <form className="addProductForm" onSubmit={handleSubmit}>
      
//         <div className="addProductItem">
//           <label>Image</label>
//           <input type="file" onChange={handleImage} />

//           {loading && <p>Uploading...</p>}

//           {product.image && (
//             <img
//               src={product.image}
//               alt="preview"
//               style={{ width: "100px", marginTop: "10px" }}
//             />
//           )}
//         </div>

//         {/* Name */}
//         <div className="addProductItem">
//           <label>Name</label>
//           <input
//             type="text"
//             name="name"
//             placeholder="Apple Watch"
//             onChange={handleChange}
//             required
//           />
//         </div>

//         {/* Price */}
//         <div className="addProductItem">
//           <label>Price</label>
//           <input
//             type="number"
//             name="price"
//             placeholder="1000"
//             onChange={handleChange}
//             required
//           />
//         </div>

//         {/* Stock */}
//         <div className="addProductItem">
//           <label>Stock</label>
//           <input
//             type="number"
//             name="stock"
//             placeholder="123"
//             onChange={handleChange}
//           />
//         </div>

//         {/* Category */}
//         <div className="addProductItem">
//           <label>Category</label>
//           <input
//             type="text"
//             name="category"
//             placeholder="Electronics"
//             onChange={handleChange}
//           />
//         </div>

//         {/* Subcategory */}
//         <div className="addProductItem">
//           <label>Sub Category</label>
//           <input
//             type="text"
//             name="subcategory"
//             placeholder="Smart Watch"
//             onChange={handleChange}
//           />
//         </div>

//         {/* Brand */}
//         <div className="addProductItem">
//           <label>Brand</label>
//           <input
//             type="text"
//             name="brand"
//             placeholder="Apple"
//             onChange={handleChange}
//           />
//         </div>

//         {/* Sizes */}
//         <div className="addProductItem">
//           <label>Sizes (comma separated)</label>
//           <input
//             type="text"
//             placeholder="S, M, L"
//             onChange={(e) =>
//               setProduct({
//                 ...product,
//                 sizes: e.target.value.split(",").map((s) => s.trim()),
//               })
//             }
//           />
//         </div>

//         {/* Colors */}
//         <div className="addProductItem">
//           <label>Colors (comma separated)</label>
//           <input
//             type="text"
//             placeholder="Red, Blue, Black"
//             onChange={(e) =>
//               setProduct({
//                 ...product,
//                 colors: e.target.value.split(",").map((c) => c.trim()),
//               })
//             }
//           />
//         </div>

//         {/* Description */}
//         <div className="addProductItem">
//           <label>Description</label>
//           <textarea
//             name="description"
//             placeholder="Write product details..."
//             onChange={handleChange}
//           />
//         </div>

//         {/* Status */}
//         <div className="addProductItem">
//           <label>Status</label>
//           <select name="status" onChange={handleChange}>
//             <option value="Active">Active</option>
//             <option value="Inactive">Inactive</option>
//           </select>
//         </div>

//         {/* Homepage Control */}
// <div className="addProductItem">
//   <label>Homepage Control</label>

//   <div>
//     <input
//       type="checkbox"
//       checked={product.isFeatured}
//       onChange={(e) =>
//         setProduct({ ...product, isFeatured: e.target.checked })
//       }
//     />
//     <span> Featured</span>
//   </div>

//   <div>
//     <input
//       type="checkbox"
//       checked={product.isPopular}
//       onChange={(e) =>
//         setProduct({ ...product, isPopular: e.target.checked })
//       }
//     />
//     <span> Popular</span>
//   </div>

//   <div>
//     <input
//       type="checkbox"
//       checked={product.isTrending}
//       onChange={(e) =>
//         setProduct({ ...product, isTrending: e.target.checked })
//       }
//     />
//     <span> Trending</span>
//   </div>

//   <div>
//     <input
//       type="checkbox"
//       checked={product.isTopSelling}
//       onChange={(e) =>
//         setProduct({ ...product, isTopSelling: e.target.checked })
//       }
//     />
//     <span> Top Selling</span>
//   </div>

//   <div>
//     <input
//       type="checkbox"
//       checked={product.isDealsOfDay}
//       onChange={(e) =>
//         setProduct({ ...product, isDealsOfDay: e.target.checked })
//       }
//     />
//     <span> Deals Of Day</span>
//   </div>
// </div>

//         {/* Submit */}
//         <button
//           className="addProductButton"
//           type="submit"
//           disabled={loading}
//         >
//           {loading ? "Uploading..." : "Create"}
//         </button>
//       </form>
//     </div>
//   );
// };

// export default NewProduct;


import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../../config/api";
import "./newProduct.css";

const NewProduct = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [product, setProduct] = useState({
    name: "",
    stock: "",
    status: "Active",
    image: "",
    price: "",
    category: "",
    subcategory: "",
    brand: "",
    sizes: [],
    colors: [],
    description: "",

    // homepage controls
    isFeatured: false,
    isPopular: false,
    isTrending: false,
    isTopSelling: false,
    isDealsOfDay: false,

    // ✅ NEW CONTROLS ADDED
    isBanner: false,
    isAd: false,
    isRecentlyAdded: false,
    isTopRated: false,
  });

  // upload image
  const uploadImageToCloudinary = async (file) => {
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", "SulavSewa");
    data.append("cloud_name", "dknqhkkhy");

    try {
      const res = await fetch(
        "https://api.cloudinary.com/v1_1/dknqhkkhy/image/upload",
        {
          method: "POST",
          body: data,
        }
      );

      const result = await res.json();
      return result.secure_url;
    } catch (err) {
      console.error("Upload failed", err);
      return null;
    }
  };

  const handleChange = (e) => {
    setProduct({
      ...product,
      [e.target.name]: e.target.value,
    });
  };

  const handleImage = async (e) => {
    const file = e.target.files[0];

    if (file) {
      setLoading(true);
      const imageUrl = await uploadImageToCloudinary(file);
      setLoading(false);

      if (imageUrl) {
        setProduct({ ...product, image: imageUrl });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!product.name.trim()) return alert("Product name is required");
    if (!product.price) return alert("Price is required");
    if (!product.image) return alert("Please upload image");

    const payload = {
      name: product.name.trim(),
      image: product.image,
      price: Number(product.price),
      stock: product.stock ? Number(product.stock) : 0,
      category: product.category || "General",
      subcategory: product.subcategory || "",
      brand: product.brand || "",
      sizes: product.sizes || [],
      colors: product.colors || [],
      description: product.description || "",
      status: product.status || "Active",
      discount: product.discount ? Number(product.discount) : 0,

      // existing
      isFeatured: product.isFeatured,
      isPopular: product.isPopular,
      isTrending: product.isTrending,
      isTopSelling: product.isTopSelling,
      isDealsOfDay: product.isDealsOfDay,

      // ✅ NEW
      isBanner: product.isBanner,
      isAd: product.isAd,
      isRecentlyAdded: product.isRecentlyAdded,
      isTopRated: product.isTopRated,
    };

    try {
      const res = await fetch(`${API_URL}/api/products`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await res.json();
      console.log("CREATED:", data);

      alert("Product Created Successfully");
      navigate("/products");
    } catch (err) {
      console.error(err);
      alert("Error creating product");
    }
  };

  return (
    <div className="newProduct">
      <h1 className="addProductTitle">New Product</h1>

      <form className="addProductForm" onSubmit={handleSubmit}>
        
        {/* IMAGE */}
        <div className="addProductItem">
          <label>Image</label>
          <input type="file" onChange={handleImage} />

          {loading && <p>Uploading...</p>}

          {product.image && (
            <img src={product.image} alt="preview" style={{ width: "100px" }} />
          )}
        </div>

        {/* NAME */}
        <div className="addProductItem">
          <label>Name</label>
          <input type="text" name="name" onChange={handleChange} required />
        </div>

        {/* PRICE */}
        <div className="addProductItem">
          <label>Price</label>
          <input type="number" name="price" onChange={handleChange} required />
        </div>

        {/* STOCK */}
        <div className="addProductItem">
          <label>Stock</label>
          <input type="number" name="stock" onChange={handleChange} />
        </div>

        {/* CATEGORY */}
        <div className="addProductItem">
          <label>Category</label>
          <input type="text" name="category" onChange={handleChange} />
        </div>

        {/* SUBCATEGORY */}
        <div className="addProductItem">
          <label>Sub Category</label>
          <input type="text" name="subcategory" onChange={handleChange} />
        </div>

        {/* BRAND */}
        <div className="addProductItem">
          <label>Brand</label>
          <input type="text" name="brand" onChange={handleChange} />
        </div>

        {/* SIZES */}
        <div className="addProductItem">
          <label>Sizes</label>
          <input
            type="text"
            onChange={(e) =>
              setProduct({
                ...product,
                sizes: e.target.value.split(",").map((s) => s.trim()),
              })
            }
          />
        </div>

        {/* COLORS */}
        <div className="addProductItem">
          <label>Colors</label>
          <input
            type="text"
            onChange={(e) =>
              setProduct({
                ...product,
                colors: e.target.value.split(",").map((c) => c.trim()),
              })
            }
          />
        </div>
        <div className="addProductItem">
  <label>Discount (%)</label>
  <input
    type="number"
    name="discount"
    placeholder="10"
    onChange={handleChange}
  />
</div>

        {/* DESCRIPTION */}
        <div className="addProductItem">
          <label>Description</label>
          <textarea name="description" onChange={handleChange} />
        </div>

        {/* STATUS */}
        <div className="addProductItem">
          <label>Status</label>
          <select name="status" onChange={handleChange}>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        {/* ===================== */}
        {/* HOMEPAGE CONTROL */}
        {/* ===================== */}
        <div className="addProductItem">
          <label>Homepage Control</label>

          <div>
            <input type="checkbox" checked={product.isFeatured}
              onChange={(e) => setProduct({ ...product, isFeatured: e.target.checked })} />
            <span> Featured</span>
          </div>

          <div>
            <input type="checkbox" checked={product.isPopular}
              onChange={(e) => setProduct({ ...product, isPopular: e.target.checked })} />
            <span> Popular</span>
          </div>

          <div>
            <input type="checkbox" checked={product.isTrending}
              onChange={(e) => setProduct({ ...product, isTrending: e.target.checked })} />
            <span> Trending</span>
          </div>

          <div>
            <input type="checkbox" checked={product.isTopSelling}
              onChange={(e) => setProduct({ ...product, isTopSelling: e.target.checked })} />
            <span> Top Selling</span>
          </div>

          <div>
            <input type="checkbox" checked={product.isDealsOfDay}
              onChange={(e) => setProduct({ ...product, isDealsOfDay: e.target.checked })} />
            <span> Deals Of Day</span>
          </div>

          {/* NEW ONES */}
          <div>
            <input type="checkbox" checked={product.isBanner}
              onChange={(e) => setProduct({ ...product, isBanner: e.target.checked })} />
            <span> Banner</span>
          </div>

          <div>
            <input type="checkbox" checked={product.isAd}
              onChange={(e) => setProduct({ ...product, isAd: e.target.checked })} />
            <span> Ads</span>
          </div>

          <div>
            <input type="checkbox" checked={product.isRecentlyAdded}
              onChange={(e) => setProduct({ ...product, isRecentlyAdded: e.target.checked })} />
            <span> Recently Added</span>
          </div>

          <div>
            <input type="checkbox" checked={product.isTopRated}
              onChange={(e) => setProduct({ ...product, isTopRated: e.target.checked })} />
            <span> Top Rated</span>
          </div>
        </div>

        {/* SUBMIT */}
        <button className="addProductButton" type="submit" disabled={loading}>
          {loading ? "Uploading..." : "Create"}
        </button>
      </form>
    </div>
  );
};

export default NewProduct;